export default __webpack_public_path__ + "dca300fce1955f10f176c5c2de043f59.png";